// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"83723145","189":"c35bb236"}[chunkId] + ".chunk.css";
};